import { withLoader } from 'util/routeHelper';
import { openMessageModal } from 'actions/modal';

export default store => ({
	path: 'login',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Login',
				),
			store,
			'LOGIN',
		),
	},
	onEnter: () => {
		store.dispatch(openMessageModal('loginSignup', { type: 'loginForm' }));
	},
});



// WEBPACK FOOTER //
// ./src/routes/Login/index.js